import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../assets/styles/ProductSlider.css";

gsap.registerPlugin(ScrollTrigger);

function Aspirations({data, image}) {
  const sectionsRef = useRef([]);

  useEffect(() => {
    sectionsRef.current.forEach((section) => {
      gsap.fromTo(
        section,
        { opacity: 0.3, scale: 0.8 },
        {
          opacity: 1,
          scale: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%", // Animation triggers when the section is 80% visible
            toggleActions: "play none none reverse",
          },
        }
      );
    });
  }, []);

  return (
    <div className="md:h-screen overflow-hidden font-roboto">
      <div
        className="md:h-screen bg-cover bg-center transition-all duration-1000"
        style={{
          backgroundImage: `url(${image})`,
        }}
      >
        <div className="flex items-center justify-center h-full flex-col md:flex-row product-card-container m-auto md:gap-10 gap-5 py-10 md:py-0">
          {/* Our Vision */}
          {data.map((items, index) => (
            <div
              ref={(el) => (sectionsRef.current[index] = el)}
              className="bg-[#000000ab] p-10 md:min-h-[680px] flex-1 opacity-0 scale-90"
              key={index}
            >
              <h1 className="text-5xl font-medium text-white pb-6 font-mono">
                {items.title}
              </h1>
              <ul className="text-left space-y-4 text-white text-xl font-poppins">
                {items.points.map((item, index) => (
                  <li
                    key={index}
                    dangerouslySetInnerHTML={{ __html: item }}
                  ></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Aspirations;
